import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Montres Neuves", href: "#neuves" },
  { label: "Montres d'Occasion", href: "#occasion" },
  { label: "Réparation", href: "#reparation" },
  { label: "Or & Bijoux", href: "#or-bijoux" },
  { label: "À propos", href: "#apropos" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // White text while over dark hero, navy text after scroll
  const textClass = scrolled ? "text-[#001226]" : "text-white";
  const subText = scrolled ? "text-[#1E2A40]" : "text-white/90";

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F8F4EC]/90 backdrop-blur-xl border-b border-[#001226]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-5 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#hero"
          data-testid="logo-link"
          className="flex items-center gap-3 group"
        >
          <img
            src="/logo.png"
            alt="Adjugé-Vendu"
            className={`h-8 md:h-12 w-auto select-none transition ${
              scrolled ? "" : "drop-shadow-lg brightness-0 invert"
            }`}
            draggable={false}
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.href.replace("#", "")}`}
              className={`nav-link text-[12px] uppercase tracking-[0.22em] ${subText} hover:text-accent transition-colors`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="#estimation"
            data-testid="header-cta-estimation"
            className="text-[11px] uppercase tracking-[0.22em] px-5 py-3 bg-accent text-white hover:bg-accent-dark transition-colors"
          >
            Estimation gratuite
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
          className={`lg:hidden p-2 ${textClass}`}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#F8F4EC] border-t border-[#001226]/10"
        >
          <div className="px-6 py-8 flex flex-col gap-5">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.href.replace("#", "")}`}
                className="text-sm uppercase tracking-[0.2em] text-[#1E2A40] hover:text-accent"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#estimation"
              onClick={() => setOpen(false)}
              className="mt-4 text-center text-[11px] uppercase tracking-[0.22em] px-5 py-3 bg-accent text-white"
            >
              Estimation gratuite
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
